import { useMutation } from '@tanstack/react-query';

import {
  createRfqBuilder,
  CreateRfqBuilderPayload
} from '../api/createRfqBuilder';

export const useCreateRfqBuilder = () => {
  return useMutation({
    mutationFn: async (payload: CreateRfqBuilderPayload) => {
      return await createRfqBuilder(payload);
    }
  });
};
